export const PLATFORMS = {
  MICROSOFT: 'microsoft',
  META: 'meta',
  GOOGLE: 'google',
} as const

export type Platforms = (typeof PLATFORMS)[keyof typeof PLATFORMS]
export type ServerSidePlatformsNames =
  | 'Microsoft'
  | 'Meta'
  | 'Google'
  | 'GoogleAdsAudience'
  | 'PixelGuard'
  | 'Other'

export const CONNECTION_STATUS = {
  CONNECTED: 'Connected',
  DISCONNECTED: 'Disconnected',
  PENDING: 'Pending',
} as const
export type ConnectionStatus = (typeof CONNECTION_STATUS)[keyof typeof CONNECTION_STATUS]

export const PROTECTION_TYPES = {
  AUTO: 'auto',
  ADVANCED: 'advanced',
} as const

export type ProtectionType = (typeof PROTECTION_TYPES)[keyof typeof PROTECTION_TYPES]

export const MCC_STATUSES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING',
} as const

export type MccStatuses = (typeof MCC_STATUSES)[keyof typeof MCC_STATUSES]

export const PLATFORM_MODALS = {
  googleMultiAccDisable: 'googleMultiAccDisable',
  googleMultiAccEdit: 'googleMultiAccEdit',
  connectionModal: 'connectionModal',
  connectionModalEdit: 'connectionModalEdit',
  pixelGuardModal: 'pixelGuardModal',
  confirmationModal: 'confirmationModal',
  audienceModal: 'audienceModal',
  successModal: 'successModal',
} as const

export type PlatformModals = (typeof PLATFORM_MODALS)[keyof typeof PLATFORM_MODALS]

export interface PlatformAccountSelection {
  platform: Platforms
  accountId: number
  connectionId?: number
}

export type GenericPlatformEntity = {
  id: number
  name: string
  domainId?: number
  selected: boolean
  adAccountId?: string
  adAccountID?: string // bug in server, should be adAccountId; let it be for now
  campaignId?: string
  managerId?: string
  adAccount?: {
    id: string
    adAccountId: number
    name: string
  }
}

export type Pixel = {
  id: number
  domainId: number
  name: string
  selected: boolean
  adAccountId: string
  domainIds?: number[]
  adAccount?: {
    id: string
    adAccountId: number
    name: string
  }
}

export type AccountId = {
  id: number
  name: string
  selected: boolean
  adAccountId: string
  adAccountID?: string // bug in server, should be adAccountId; let it be for now
  protectAllAdSets: boolean
}

export type BusinessManager = {
  id: number
  name: string
  selected: boolean
  managerId: string
}

export type CampaignId = {
  id: number
  name: string
  selected: boolean
  campaignId?: string
  status: string
}

export type AdSet = {
  id: number
  name: string
  selected: boolean
  adAccountId?: string
}

export type PlatformStatus = {
  connectionStatus: ConnectionStatus
  platformType: ServerSidePlatformsNames
  enabled: boolean
  connectionId: number
  connectionType?: (typeof GOOGLE_CONNECTION_TYPES)[keyof typeof GOOGLE_CONNECTION_TYPES]
  displayId: string
  displayName: string
}

export type PlatformConnection = {
  connectionId: number
  platformType: ServerSidePlatformsNames
  adAccountId: number
  platformAdAccountId: string
}

export const PLATFORM_ENTITY_TYPES = {
  AD_ACCOUNT: 'AdAccount',
  AUDIENCE: 'Audience',
  PIXEL_GUARD: 'PixelGuard',
} as const

export type PlatformConnectionEntityTypes =
  (typeof PLATFORM_ENTITY_TYPES)[keyof typeof PLATFORM_ENTITY_TYPES]

export const GOOGLE_CONNECTION_TYPES = {
  MCC: 'MCC',
  SSO: 'SSO',
} as const

export interface Connection {
  connectionId: number
  platformType: ServerSidePlatformsNames
  entityType: PlatformConnectionEntityTypes
  entityId: number
  displayId: string
  connectionType?: (typeof GOOGLE_CONNECTION_TYPES)[keyof typeof GOOGLE_CONNECTION_TYPES]
  domainAddress?: string
  manager?: boolean
}

export type PlatformObjKey = keyof PlatformConnection

export interface PlatformConnectionSelectionEntity {
  label: ServerSidePlatformsNames | string
  value: string
}

export const platformOptions: PlatformConnectionSelectionEntity[] = [
  { label: 'Meta', value: 'FacebookPaid' },
  { label: 'Google', value: 'GOOGLEPAID' },
  { label: 'Microsoft', value: 'microsoft' },
  { label: 'Other', value: 'OTHER' },
]
